import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UberweiserOpenDialogComponent} from './uberweiser-open-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        MatIconModule
    ],
    declarations: [UberweiserOpenDialogComponent],
    exports: [UberweiserOpenDialogComponent]
})
export class UberweiserOpenDialogModule {
}
